import { Component, OnInit, OnDestroy } from '@angular/core';
import { MatMenuModule } from '@angular/material/menu';
import { MatTooltipModule } from '@angular/material/tooltip';
import { MatButtonModule } from '@angular/material/button';
import { MatToolbarModule } from '@angular/material/toolbar';
import { MatSidenavModule} from '@angular/material/sidenav';
import { MatListModule } from '@angular/material/list';
import { MatCardModule } from '@angular/material/card';
import { MatIconModule } from '@angular/material/icon';
import { HeaderModule } from "./shared/header/header.module";
import { FooterModule } from "./shared/footer/footer.module";
import { RouterLink } from '@angular/router';
import { RouterOutlet } from '@angular/router';
import { CommonModule } from '@angular/common';
import { Subject } from 'rxjs';

@Component({
  selector: 'app-root',
  templateUrl: './app.component.html',
  styleUrl: './app.component.css',
  standalone: true,
  imports: [CommonModule, 
            RouterOutlet, 
            RouterLink, 
            MatCardModule, 
            MatToolbarModule, 
            MatTooltipModule, 
            MatButtonModule, 
            MatMenuModule, 
            MatSidenavModule, 
            MatListModule,
            MatIconModule,
            HeaderModule, 
            FooterModule, 
          ]
})
export class AppComponent implements OnInit, OnDestroy {
  title = 'web-partner-offline-ui-hfsv';
  private readonly _destroying$ = new Subject<void>();

  constructor() { }

  ngOnInit(): void {
    
  }

  ngOnDestroy(): void {
    this._destroying$.next(undefined);
    this._destroying$.complete();
  }
}

